/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impressum_Hrb_PendingInputs */

const en_impressum_hrb_pending = /** @type {(inputs: Impressum_Hrb_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EliteX GbR is a civil-law partnership (Gesellschaft buergerlichen Rechts). Registration in the commercial register is not required.`)
};

const de_impressum_hrb_pending = /** @type {(inputs: Impressum_Hrb_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EliteX GbR ist eine Gesellschaft buergerlichen Rechts. Eine Eintragung im Handelsregister ist nicht erforderlich.`)
};

const fr_impressum_hrb_pending = /** @type {(inputs: Impressum_Hrb_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EliteX GbR est une société civile de droit allemand (Gesellschaft bürgerlichen Rechts). L'inscription au registre du commerce n'est pas requise.`)
};

const es_impressum_hrb_pending = /** @type {(inputs: Impressum_Hrb_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EliteX GbR es una sociedad civil (Gesellschaft bürgerlichen Rechts). No es necesaria la inscripción en el registro mercantil.`)
};

const it_impressum_hrb_pending = /** @type {(inputs: Impressum_Hrb_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EliteX GbR è una società di diritto civile (Gesellschaft bürgerlichen Rechts). L'iscrizione al registro commerciale non è obbligatoria.`)
};

const nl_impressum_hrb_pending = /** @type {(inputs: Impressum_Hrb_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EliteX GbR is een maatschap naar burgerlijk recht (Gesellschaft bürgerlichen Rechts). Inschrijving in het handelsregister is niet vereist.`)
};

const pl_impressum_hrb_pending = /** @type {(inputs: Impressum_Hrb_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EliteX GbR jest spółką cywilną (Gesellschaft bürgerlichen Rechts). Wpis do rejestru handlowego nie jest wymagany.`)
};

const fi_impressum_hrb_pending = /** @type {(inputs: Impressum_Hrb_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EliteX GbR on siviilioikeudellinen yhtiö (Gesellschaft bürgerlichen Rechts). Kaupparekisteriin merkitsemistä ei edellytetä.`)
};

const da_impressum_hrb_pending = /** @type {(inputs: Impressum_Hrb_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EliteX GbR er et interessentskab (Gesellschaft bürgerlichen Rechts). Registrering i handelsregisteret er ikke påkrævet.`)
};

const sv_impressum_hrb_pending = /** @type {(inputs: Impressum_Hrb_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EliteX GbR är ett enkelt bolag (Gesellschaft buergerlichen Rechts). Registrering i handelsregistret krävs inte.`)
};

/**
* | output |
* | --- |
* | "EliteX GbR is a civil-law partnership (Gesellschaft buergerlichen Rechts). Registration in the commercial register is not required." |
*
* @param {Impressum_Hrb_PendingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const impressum_hrb_pending = /** @type {((inputs?: Impressum_Hrb_PendingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impressum_Hrb_PendingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_impressum_hrb_pending(inputs)
	if (locale === "fr") return fr_impressum_hrb_pending(inputs)
	if (locale === "es") return es_impressum_hrb_pending(inputs)
	if (locale === "it") return it_impressum_hrb_pending(inputs)
	if (locale === "nl") return nl_impressum_hrb_pending(inputs)
	if (locale === "pl") return pl_impressum_hrb_pending(inputs)
	if (locale === "fi") return fi_impressum_hrb_pending(inputs)
	if (locale === "da") return da_impressum_hrb_pending(inputs)
	if (locale === "sv") return sv_impressum_hrb_pending(inputs)
	return en_impressum_hrb_pending(inputs)
});